<template>
  <BaseTableView :head="tableHead">
    <WorkClientAddressTableItem v-for="item in items" :key="item.id" :item="item" />
  </BaseTableView>
</template>

<script>
import WorkClientAddressTableItem from 'components/workClient/address/WorkClientAddressTableItem'
export default {
  name: 'WorkClientAddressTable',
  props: ['items'],
  components: { WorkClientAddressTableItem },
  data() {
    return {}
  },
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages['setting-client']['address']['ulitsa'],
          sort: {
            name: 'street',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'street'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'asc',
          },
        },
        {
          text: this.localStorage.translations.pages['setting-client']['address']['indeks'],
          sort: {
            name: 'zip',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'zip'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'asc',
          },
        },
        {
          text: this.localStorage.translations.pages['setting-client']['address']['gorod'],
          sort: {
            name: 'city',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'city'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'asc',
          },
        },
        {
          text: this.localStorage.translations.pages['setting-client']['address']['opisanie'],
        },
        {
          text: this.localStorage.translations.pages['setting-client']['address']['filial'],
        },
        {active: true},
      ]
    },
  },
  methods: {},
  watch: {},
}
</script>
